import get from 'lodash.get';
import {
  DOMAIN_PREFIX,
  LANGUAGE_VALUE,
  domainCode,
  languageFlagLink,
} from '../../../../constants/staticPageConstants';
import { processURL } from '../../../../utils/static-pages/urlProcessor';
import { LANG_DATA } from './dataset';

export const getLangText = (alt_language: number): JSX.Element => {
  const language = get(LANGUAGE_VALUE, alt_language, 'English');
  const flagLink = get(
    languageFlagLink,
    language,
    'https://assets.clear.in/cleartax/images/1747998895_image.png'
  );

  const langData = get(LANG_DATA, language, LANG_DATA.English);
  if (!langData) return <></>;
  return (
    <div className="flex items-center">
      <span className="pt-0.5 h-5 w-4 flex items-center">
        <img alt="langFlag" src={flagLink} />
      </span>
      <div className="px-2 text-font-200 flex-1 text-inherit">
        {langData.lang_name}
      </div>
    </div>
  );
};

export const generateLink = (
  permalink: string,
  languageValue: string,
  domain: number
): string => {
  let DOMAINPREFIX = '';
  if (domain === domainCode.cleartaxIn) {
    DOMAINPREFIX = `https://${DOMAIN_PREFIX[domain]?.host}`;
  } else {
    DOMAINPREFIX = `https://www.${DOMAIN_PREFIX[domain]?.host}`;
  }
  return `${DOMAINPREFIX}/${processURL(permalink, languageValue, domain)}`;
};
